<template>
    <div class="mt-5 pt-5">
        <a-form layout="Vertical" :form="form" class="mt-5">
            <a-row>
                <a-col :span="11">
                    <a-form-item label="单位名称：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['enterpriseName',{initialValue:enterpriseName, rules: [{required: true,message: '单位名称不能为空'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="统一社会信用代码：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                disabled
                                v-decorator="['enterpriseCode',{initialValue:enterpriseCode}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11">
                    <a-form-item label="负责人：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['legalPerson',{initialValue:en.legalPerson, rules: [{required: true,message: '法人代表不能为空'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="负责人身份证号码：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['legalIdCard', {initialValue:en.legalIdCard ,rules: [{ required: true, message: '身份证不能为空'},{validator: iDCardValidate}]}]"
                        />
                    </a-form-item>
                </a-col>

                <a-col :span="11" >
                    <a-form-item label="手机号：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['contactsPhone',{initialValue:en.contactsPhone ,rules: [{message: '输入正确的手机号码', required: true},{validator: phoneValidate}]}]"
                        />
                    </a-form-item>
                </a-col>

                <a-col :span="11">
                    <a-form-item label="电子邮件：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                v-decorator="['email',{initialValue:en.email, rules: [{ required: true, message: '邮箱不能为空'},{type: 'email',message: '邮箱格式不正确'}]}]"
                        />
                    </a-form-item>
                </a-col>


                <a-col :span="11">
                    <a-form-item label="省/市/县：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <area-select type='all' size="small" :level='2' :data="pcaa" @change="change"
                                     v-model="selected"></area-select>
                    </a-form-item>
                    <a-form-item label="详细地址：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                                :addon-before="complete"
                                v-decorator="['supplierAddress',{initialValue:en.supplierAddress ,rules: [{ required: true, message: '注册地址不能为空'}]}]"
                        />
                    </a-form-item>
                </a-col>
                <a-col :span="11" :offset="1">
                    <a-form-item label="经营范围：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-textarea style="height: 100px;"
                                    v-decorator="['businessScope',{initialValue:en.businessScope, rules: [{ required: true, message: '请输入经营范围' },{validator: scopeValidate}]}]"
                        >
                        </a-textarea>
                    </a-form-item>
                </a-col>

                <a-col :span="11" :offset="1">
                    <a-form-item label="成立时间：" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-date-picker format="YYYY-MM-DD"
                                       v-decorator="['foundDate',{initialValue:en.foundDate, rules: [{ required: true, message: '成立时间不能为空' },{validator: foundDateValidate}]}]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="15">
                    <a-form-item label="营业执照扫描件需盖公章：" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                        <span style="color: red;font-size: 10px;">只支持JPEG或JPG格式文件,最大2MB</span>
                        <upload-selector
                                :referId='en.cmtId'
                                ref="UploadSelector"
                                :max="2"
                                value="license"
                                configKey='UCARD' />
                    </a-form-item>
                </a-col>
            </a-row>

            <a-form-item class="text-center">
                <a-button style="margin-left: 8px;width: 150px" @click="prevStep">上一步</a-button>
                <span> &nbsp;&nbsp;&nbsp;</span>
                <a-button style="width: 150px" :loading="loading" type="primary" @click="nextStep">提交</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from "moment";
    import DictCascader from '@/components/dict/DictCascader'
    import qs from "qs";

    export default {
        created() {
            console.log(this.enterpriseName+ "   "+ this.enterpriseCode)
            this.initData()
        },
        props:{
            enterpriseName: {
                type: String,
                default: ''
            },
            enterpriseCode: {
                type: String,
                default: ''
            }
        },
        components: {
            UploadSelector,
            moment,
            DictCascader
        },
        name: 'ModifyIndividualStep2',
        data () {
            return {
                labelCol: { lg: { span: 6 }, sm: { span: 6 } },
                wrapperCol: { lg: { span: 18 }, sm: { span: 18 } },
                form: this.$form.createForm(this),
                loading: false,
                timer: 0,
                modalLoading: false,
                pca: pca,
                pcaa: pcaa,
                queryParam: {},
                small: 'small',
                supplier: '',
                city: '',
                province: '',
                district: '',
                cityName: '',
                provinceName: '',
                districtName: '',
                // selected:[pcaa[86][110000],pcaa[110000][110100],pcaa[110100][110101]],
                selected: [],
                account: '',
                en: '',
                audit:'',
                complete:''
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get("/api/v1/supplier/enterprise/getModifyInitInfo.json").then(function (res) {
                    console.log(res)
                    that.en = res.result
                    if (that.en.foundDate) {
                        that.en.foundDate = moment(that.en.foundDate)
                    }
                    that.selected = []
                    if (that.en.province) {
                        that.selected.push(that.pcaa[86][that.en.province])
                    }
                    if (that.en.province && that.en.city) {
                        that.selected.push(that.pcaa[that.en.province][that.en.city])
                    }
                    if (that.en.province && that.en.city && that.en.district) {
                        // pcaa['110100']['110101']
                        that.selected.push(that.pcaa[that.en.city][that.en.district])
                    }
                    if (that.en.registerCapital){
                        that.en.registerCapital = that.en.registerCapital + ""
                    }
                });
            },
            nextStep() {
                debugger
                let params = {...this.form.getFieldsValue()}
                if (this.selected.length !== 3) {
                    this.$message.error('请选择省市县不能为空!')
                    return
                }
                for (var p in this.selected[0]) {
                    this.province = p
                    this.provinceName = this.selected[0][p]
                }
                for (var p in this.selected[1]) {
                    this.city = p
                    this.cityName = this.selected[1][p]
                }
                for (var p in this.selected[2]) {
                    this.district = p
                    this.districtName = this.selected[2][p]
                }
                if (this.cityName === '市辖区' ) {
                    params.registerAddress = this.provinceName  + this.districtName + params.supplierAddress
                }else {
                    params.registerAddress = this.provinceName + this.cityName + this.districtName + params.supplierAddress
                }
                if (params.businessScope.length > 500){
                    this.$message.error("经营范围不能超过500字");
                    return;
                }
                let that = this
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    params.province = this.province
                    params.city = this.city
                    params.district = this.district
                    params.enterpriseId = this.en.enterpriseId
                    params.id = this.en.id

                    if (params.foundDate && params.foundDate != null) {
                        params.foundDate = params.foundDate.format("YYYY-MM-DD")
                    }
                    if (Date.parse(params.foundDate) > new Date()) {
                        that.$message.error("注册时间不得晚于当前日期")
                        return
                    }

                    if (this.$refs.UploadSelector.uploadFiles && this.$refs.UploadSelector.uploadFiles.length < 1) {
                        that.$message.error("营业执照扫描件必须上传!")
                        return
                    }
                    that.doSubmit(params)
                })
            },
            doSubmit(params) {
                let that = this
                params.enterpriseCode = that.enterpriseCode
                params.supplierType = '1'
                params.authType = '2'
                that.loading = true
                that.$http.post("/api/v1/supplier/enterprise/modifyCertificateInfo.json", qs.stringify(params, {allowDots: true})).then(function (res) {
                    if (res.code === 200) {
                        that.timer = setTimeout(function () {
                            that.loading = false
                            that.$emit('nextStep')
                        }, 1500)}
                })
            },
            change(e) {
                this.complete = ''
                var area = ''
                for (let i = 0; i < e.length; i++) {
                    var it = e[i]
                    console.log(it)
                    for (var p in it) {
                        area =  area + it[p]
                    }
                }
                if (area.indexOf("市辖区") != -1) {
                    area = area.replace("市辖区","")
                }
                this.complete = area
            },
            prevStep () {
                this.$emit('prevStep')
            },
            foundDateValidate(rule,value,callback) {
                if (value && Date.parse(value) > new Date()) {
                    callback('注册时间必须早于当前时间');
                }
                callback()
            },
            iDCardValidate(rule, value, callback) {
                if (!value) {
                    callback()
                }
                var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                if (!reg.test(value)) {
                    callback("负责人身份证格式不正确")
                }
                callback()
            },
            phoneValidate(rule, value, callback) {
                // var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                var reg = /^[1][3-9][0-9]{9}$/
                if (value && !reg.test(value)) {
                    callback("手机号格式不正确")
                }
                callback()
            },
            scopeValidate(rule, value, callback) {
                if (value && value.length > 500) {
                    callback("经营范围不能超过500字")
                }
                callback()
            },
        },
        beforeDestroy () {
            clearTimeout(this.timer)
        }
    }
</script>

<style lang="less" scoped>
    .area-select-wrap{
        display: flex;
        justify-content: space-between;
        margin-top: 4px;
    }
    .area-select .area-selected-trigger {
        position: relative;
        display: block;
        font-size: 14px;
        cursor: pointer;
        margin: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 100%;
        padding: 0 12px;
        line-height: 30px;
        background: #000;
    }
    .area-select-wrap .area-select {
        margin-left: 0;
    }
    .area-select.small {
        width: 31%;
    }
</style>
